import { useEffect } from 'react';
import { AccessibilityInfo } from 'react-native';
import { useSetRecoilState } from 'recoil';

import { screenReaderEnabledState } from '@store';

import { isAndroid, isTizen, isX1 } from '../helpers/Platform';

/**
 * Detect if screen reader is enabled. Different implementations for different platforms.
 * TBD: Tizen?
 */
export const useScreenReaderEnabled = () => {
  const setScreenReaderEnabledState = useSetRecoilState(screenReaderEnabledState);

  useEffect(() => {
    if (isAndroid) {
      const screenReaderChangedSubscription = AccessibilityInfo.addEventListener(
        'screenReaderChanged',
        screenReaderEnabled => {
          setScreenReaderEnabledState(screenReaderEnabled);
        },
      );

      AccessibilityInfo.isScreenReaderEnabled().then(screenReaderEnabled => {
        setScreenReaderEnabledState(screenReaderEnabled);
      });

      return () => {
        screenReaderChangedSubscription?.remove();
      };
    }

    if (isX1) {
      $badger
        .userPreferences()
        .voiceGuidance()
        .success(function (data) {
          setScreenReaderEnabledState(data.enabled);
        })
        .failure(function (error) {
          console.log(JSON.stringify(error));
        });
    }

    if (isTizen) {
      const tizenScreenReaderEnabledListener = window.webapis.tvinfo.addCaptionChangeListener(
        window.webapis.tvinfo.TvInfoMenuKey.VOICE_GUIDE_KEY,
        () => {
          tizenSetScreenReaderEnabled();
        },
      );

      tizenSetScreenReaderEnabled();

      return () => {
        tizenScreenReaderEnabledListener?.remove();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tizenSetScreenReaderEnabled = () => {
    const screenReaderEnabled = window.webapis.tvinfo.getMenuValue(window.webapis.tvinfo.TvInfoMenuKey.VOICE_GUIDE_KEY);

    setScreenReaderEnabledState(!!+screenReaderEnabled);
  };
};
